import Vue from 'vue';
import { $httpChangiRecommends } from '@/core/api';
import { mapState } from 'vuex';
export default Vue.extend({
    computed: {
        ...mapState('userModule', ['user']),
    },
    data() {
        return {
            sendingConfirmationEmail: false,
            confirmationMessage: '',
        };
    },
    methods: {
        resendEmail() {
            if (this.sendingConfirmationEmail === false &&
                !this.confirmationMessage) {
                this.sendingConfirmationEmail = true;
                $httpChangiRecommends.api
                    .resendRegisterVerificationEmail(this.user.uuid)
                    .then(({ data }) => {
                    this.confirmationMessage = data.message;
                })
                    .catch((err) => {
                    console.error(err);
                })
                    .finally(() => {
                    this.sendingConfirmationEmail = false;
                });
            }
        },
    },
});
